export default "__VITE_ASSET__BWWpG6k5__"